import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'

// Actions
import { getChain, createSaveChain, getChainStats, getCurrencies } from '../../../actions/chains'
import { loginAs } from '../../../actions/auth'
import { API_URL } from '../../../constants'

import Confirm from '../../../shared/components/Confirm'

// import styles
import './create.scss'

// Components
import Phone from '../../../shared/components/Phone'

// Elements
import { ElementIcons } from '../../../shared/elements/icons'
import Actions from '../../../shared/elements/actions'
import Button from '../../../shared/elements/button'
import Check from '../../../shared/elements/check'
import Col from '../../../shared/elements/col'
import DateTime from '../../../shared/elements/datetime'
import Divider from '../../../shared/elements/divider'
import DropDown from '../../../shared/elements/dropDown'
import Icon from '../../../shared/elements/icon'
import Label from '../../../shared/elements/label'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Panel from '../../../shared/elements/panel'
import Radio from '../../../shared/elements/radio'
import Text from '../../../shared/elements/text'

// Utils
import { translation } from '../../../utils/helpers'

class Create extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
      chain: {
        Id: 0,
        IsActive: '',
        Name: '',
        PhoneNumber: '',
        PhoneCode: {
          Id: 0,
          Code: '',
          MinNrLength: 0,
          MaxNrLength: 0
        },
        DefaultPhoneCode: {
          Id: 0,
          Code: '',
          MinNrLength: 0,
          MaxNrLength: 0
        },
        Contact: '',
        Email: '',
        Address: '',
        Country: '',
        Logo: '',
        UseForsi: 0,
        VehicleLookupServiceId: 0,
        PaintTool: 0,
        SmsDk: '',
        SmsEu: '',
        UseBenchmark: '',
        AccessShops: '',
        DefaultCulture: 0,
        DefaultLanguage: '',
        Currency: {
          Id: 0,
          Code: ''
        },
        Administrators: [],
        // PermissionModules: [],
        AutomaticWarrantyCode: false,
        AssessmentSystem: 0
      },
      Stats: {
        StartDate: moment().subtract(1, 'month'),
        EndDate: moment()
      },
      Confirm: {
        Show: false,
        IsPermission: false,
        target: {
          value: '',
          name: '',
          checked: false
        }
      },
      dimensions: {
        width: 0,
        height: 0
      },
      currencies: []
    }

    this.updateChain = this.updateChain.bind(this)
    this.addChain = this.addChain.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this)
    // this.onModuleCheck = this.onModuleCheck.bind(this)
    this.onChangeSelect = this.onChangeSelect.bind(this)
    this.getStats = this.getStats.bind(this)
    this.confirm = this.confirm.bind(this)
    this.notConfirm = this.notConfirm.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.getCurrencies = this.getCurrencies.bind(this)
  }

  resetCreateChain () {
    this.setState({
      chain: {
        Id: 0,
        IsActive: '',
        Name: '',
        PhoneNumber: '',
        PhoneCode: {
          Id: 12,
          Code: '+45',
          MinNrLength: 8,
          MaxNrLength: 8
        },
        DefaultPhoneCode: {
          Id: 12,
          Code: '+45',
          MinNrLength: 8,
          MaxNrLength: 8
        },
        Contact: '',
        Email: '',
        Address: '',
        Country: '1750',
        Logo: '',
        UseForsi: 0,
        VehicleLookupServiceId: 0,
        PaintTool: 0,
        UseSmsDk: '',
        UseSmsEu: '',
        UseBenchmark: '',
        AccessShops: '',
        DefaultCulture: 0,
        DefaultLanguage: 'Danish',
        Currency: {
          Id: 10,
          Code: 'DKK'
        },
        Administrators: [],
        // PermissionModules: [],
        AutomaticWarrantyCode: false,
        AssessmentSystem: 0
      }
    })
  }
  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
    this.updateDimensions()
    this.getCurrencies()
    if (typeof this.props.item.ChainId === 'undefined') {
      this.resetCreateChain()
    } else {
      this.setState({
        type: 'edit'
      })
      this.getChainById(this.props.item.ChainId)
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps (nextProps) {
    if (typeof nextProps.item.ChainId === 'undefined') {
      this.resetCreateChain()
    } else {
      if (this.props.item.ChainId !== nextProps.item.ChainId) {
        this.setState({
          type: 'edit'
        })
        this.getChainById(nextProps.item.ChainId)
      }
    }
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  getCurrencies () {
    this.props.getCurrencies().then(res => {
      this.setState({
        currencies: res.data
      })
    }, err => {
      console.log(err)
    })
  }

  getChainById (id) {
    this.props.getChain(id).then((res) => {
      this.setState({
        chain: res.data
      }, () => console.log('get chain by id: ', this.state.chain))
    }, (err) => {
      console.log(err)
    })
  }

  onChange (e) {
    let names = ['Country', 'Dateformat', 'DefaultLanguage', 'VehicleLookupServiceId', 'PhoneCode']
    this.setState({
      chain: {
        ...this.state.chain,
        [e.target.name]: e.target.value
      }
    }, () => {
      if (names.includes(e.target.name)) this.updateChain()
    })
  }

  onCheckBoxChange (e, dontCheck) {
    if (!dontCheck) {
      this.setState({
        Confirm: {
          Show: true,
          IsPermission: false,
          text: e.target.name,
          target: {
            value: e.target.value,
            name: e.target.name
          }
        }
      })
      return
    }

    let checkboxValue = (e.target.name === 'PaintTool' || e.target.name === 'AssessmentSystem') ? parseInt(e.target.value, 10) : (!(e.target.value === 'true'))
    this.setState({
      chain: {
        ...this.state.chain,
        [e.target.name]: checkboxValue
      }
    }, () => {
      this.updateChain(e)
    })
  }

  onChangeSelect (e) {
    if (e.target.name === 'Currency') {
      this.setState({
        chain: {
          ...this.state.chain,
          Currency: {
            ...this.state.Currency,
            Id: e.target.value
          }
        }
      }, () => {
        this.updateChain()
      })
    } else {
      this.setState({
        chain: {
          ...this.state.chain,
          DefaultPhoneCode: {
            ...this.state.chain.DefaultPhoneCode,
            Id: e.target.value
          }
        }
      }, () => {
        if (e.target.name === 'Countrycode') this.updateChain()
      })
    }
  }

  // onModuleCheck (e, dontCheck) {
  //   if (!dontCheck) {
  //     this.setState({
  //       Confirm: {
  //         Show: true,
  //         IsPermission: true,
  //         target: {
  //           value: e.target.value,
  //           name: e.target.name,
  //           checked: e.target.checked
  //         }
  //       }
  //     })
  //     return
  //   }

  //   let modules = [...this.state.chain.PermissionModules]
  //   var value = e.target.value
  //   console.log(modules, value)
  //   if (e.target.checked === false) {
  //     modules = modules.filter(function (el) {
  //       return Number(el.PermissionModuleId) !== Number(value)
  //     })
  //   } else {
  //     modules.push({
  //       PermissionModuleId: value
  //     })
  //   }
  //   this.setState({
  //     chain: {
  //       ...this.state.chain,
  //       PermissionModules: modules
  //     }
  //   }, this.updateChain)
  // }

  loginAs (id) {
    this.props.loginAs(id).then((res) => {
      setTimeout(() => {
        this.props.router.push('/shopowners')
      }, 200)
    })
  }

  updateChain () {
    if (this.state.chain.Id !== 0) {
      this.props.createSaveChain(this.state.chain).then((res) => {
        // Toastr
        // window.toastr.success(translation('13462'), translation('13424'))
      }, () => {
        // Toastr
        window.toastr.error(translation('13463'), translation('216'))
      })
    }
  }

  addChain () {
    if (this.state.chain.Id === 0 && this.state.chain.Name.length > 0) {
      this.props.createSaveChain(this.state.chain).then((res) => {
        this.props.onSave(res.data, this.props.type)
        setTimeout(() => {
          this.props.getChains()
        }, 0)
        // Toastr
        // window.toastr.success(translation('1830'), translation('13424'))
      }, () => {
        // Toastr
        window.toastr.error(translation('1831'), translation('216'))
      })
    }
  }

  renderAdmins () {
    if (this.props.type === 'create') return null
    let chain = this.state.chain
    const adminList = (val, key) => {
      return (
        <div key={key}>
          <Label><Link to={'/chains/' + chain.Id + '/managers/' + val.UserId}>{val.Name}</Link></Label>
          {(val.UserId > 0) && (
            <Button onClick={this.loginAs.bind(this, val.UserId)} style='link' labelText={translation('57')} />
          )}
        </div>
      )
    }
    return (
      <Panel title={translation('61')}>
        <Actions>
          <Link to={'/chains/' + chain.Id + '/managers'}>
            <Icon icon={ElementIcons.Edit} size='t' />
          </Link>
        </Actions>

        {chain.Administrators.map(adminList)}
      </Panel>
    )
  }

  changeDate (name, moment) {
    this.setState({
      Stats: {
        ...this.state.Stats,
        [name]: moment
      }
    })
  }

  getStats () {
    let newFileUrl = API_URL + '/Permissions/PermissionsHistory?startDate=' + this.state.Stats.StartDate.format('DD-MM-YYYY HH:mm:ss') + '&endDate=' + this.state.Stats.EndDate.format('DD-MM-YYYY HH:mm:ss') + '&chainId=' + this.props.item.ChainId + '&token=' + encodeURIComponent(this.props.auth.user.Token)
    window.open(newFileUrl)
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width <= lessThan) show = true
      }
    })
    return show
  }

  render () {
    let chain = this.state.chain

    const renderCodes = (val, key) => {
      return (
        <option key={key} value={val.Id}>{val.Code}</option>
      )
    }
    const renderLanguage = (val, key) => {
      return (
        <option key={key} value={val}>{val}</option>
      )
    }

    let confirmText = this.state.Confirm.text === 'AssessmentSystem' ? '17933' : '14748'

    let vehicleLookupServiceOptions = [{ Id: 0, Name: 'Ingen' }]
    this.props.vehicleLookupServices.map((val) => {
      vehicleLookupServiceOptions.push({ Id: val.Id, Name: translation(val.NameDictionaryKey) })
    })
    const renderVehicleLookupService = (val, key) => {
      return (
        <option key={key} value={val.Id}>{val.Name}</option>
      )
    }

    return (
      <div className='chainCreate__screen'>
        <Col>
          {this.dimensionShow([[0, 850]]) && this.renderAdmins()}
          <Panel title={translation('346')}>
            <Text name='Name' value={chain.Name || ''} onChange={this.onChange} onBlur={this.updateChain} labelText={translation('30')} />
            <Text name='Contact' value={chain.Contact || ''} onChange={this.onChange} onBlur={this.updateChain} labelText={translation('346')} />
            <LabelWrapper labelText={translation('345')}>
              <Phone
                onChange={this.onChange}
                code={chain.PhoneCode}
                number={chain.PhoneNumber}
                name={'PhoneCode'}
                onBlur={this.updateChain} />
            </LabelWrapper>
            <Text name='Email' value={chain.Email || ''} onChange={this.onChange} onBlur={this.updateChain} labelText={translation('1052')} />
            <Text name='Address' value={chain.Address || ''} onChange={this.onChange} onBlur={this.updateChain} labelText={translation('25')} />
            <DropDown name='Country' value={parseInt(chain.Country, 10)} onChange={this.onChange} labelText={translation('1701')}>
              {this.props.countries.map((val, index) => {
                let showVal = translation(val['CountryName'])
                return <option value={val['CountryName']} key={index}>{showVal}</option>
              })}
            </DropDown>
            <Text name='Logo' value={chain.Logo || ''} onChange={this.onChange} onBlur={this.updateChain} labelText={translation('1702')} />
          </Panel>

        </Col>
        <Col>
          <Panel title={translation('6')}>
            <LabelWrapper labelText={translation('17932')}>
              <Radio id='NoAssessmentSystem' name='AssessmentSystem' value={0} onChange={this.onCheckBoxChange} checked={chain.AssessmentSystem === 0} labelText={translation('433')} />
              <Radio id='Forsi' name='AssessmentSystem' value={1} onChange={this.onCheckBoxChange} checked={chain.AssessmentSystem === 1} labelText={translation('13438')} />
              <Radio id='DBS' name='AssessmentSystem' value={2} onChange={this.onCheckBoxChange} checked={chain.AssessmentSystem === 2} labelText={translation('17930')} />
            </LabelWrapper>
            <DropDown name='VehicleLookupServiceId' onChange={this.onChange} value={chain.VehicleLookupServiceId} labelText={translation('1704')}>
              {vehicleLookupServiceOptions.map(renderVehicleLookupService)}
            </DropDown>
            <LabelWrapper labelText={translation('14964')}>
              <Radio id='NoPaintTool' name='PaintTool' value={0} onChange={this.onCheckBoxChange} checked={chain.PaintTool === 0} labelText={translation('433')} />
              <Radio id='ChromaWeb' name='PaintTool' value={1} onChange={this.onCheckBoxChange} checked={chain.PaintTool === 1} labelText='ChromaWeb' />
            </LabelWrapper>

            <Divider noLine />

            <Check id='UseSmsDk' name='UseSmsDk' value={chain.UseSmsDk} onChange={this.onCheckBoxChange} checked={chain.UseSmsDk} labelText={translation('1705')} />
            <Check id='UseSmsEu' name='UseSmsEu' value={chain.UseSmsEu} onChange={this.onCheckBoxChange} checked={chain.UseSmsEu} labelText={translation('1706')} />
            <DropDown name='Countrycode' onChange={this.onChangeSelect} value={chain.DefaultPhoneCode.Id} labelText={translation('1707')}>
              {this.props.phonecodes.map(renderCodes)}
            </DropDown>
            <DropDown name='Dateformat' onChange={this.onChange} labelText={translation('1708')}>
              <option key='1' value='1'>1</option>
              <option key='2' value='2'>2</option>
            </DropDown>
            <Text name='Vat' value={chain.Vat || ''} onChange={this.onChange} onBlur={this.updateChain} labelText={translation('14804')} />
            <Check id='UseBenchmark' name='UseBenchmark' value={chain.UseBenchmark} onChange={this.onCheckBoxChange} checked={chain.UseBenchmark} labelText={translation('1419')} />
            <Check id='AccessShops' name='AccessShops' value={chain.AccessShops} onChange={this.onCheckBoxChange} checked={chain.AccessShops} labelText={translation('1710')} />
            <DropDown name='DefaultLanguage' onChange={this.onChange} value={chain.DefaultLanguage} labelText={translation('1711')}>
              {this.props.languages.map(renderLanguage)}
            </DropDown>
            <DropDown name='Currency' onChange={this.onChangeSelect} value={chain.Currency.Id} labelText={translation('17994')}>
              {this.state.currencies.map(renderCodes)}
            </DropDown>
            <Check id='AutomaticWarrantyCode' name='AutomaticWarrantyCode' value={chain.AutomaticWarrantyCode} onChange={this.onCheckBoxChange} checked={chain.AutomaticWarrantyCode} labelText={translation('15145')} />
          </Panel>
        </Col>
        <Col>
          {!this.dimensionShow([[0, 850]]) && this.renderAdmins()}
          <Panel title={translation('389')}>
            <LabelWrapper labelText={translation('1490')}>
              <DateTime
                dateFormat='DD-MM-YYYY'
                closeOnSelect
                timeFormat={false}
                value={this.state.Stats.StartDate}
                onChange={this.changeDate.bind(this, 'StartDate')} />
            </LabelWrapper>
            <LabelWrapper labelText={translation('13516')}>
              <DateTime
                dateFormat='DD-MM-YYYY'
                closeOnSelect
                timeFormat={false}
                value={this.state.Stats.EndDate}
                onChange={this.changeDate.bind(this, 'EndDate')} />
            </LabelWrapper>
            <Button onClick={this.getStats} labelText={translation('13517')} style='link' />
          </Panel>
        </Col>

        {this.state.Confirm.Show === true && <Confirm t={translation} renderText={() => translation(confirmText)} confirm={this.confirm} notConfirm={this.notConfirm} />}
      </div>
    )
  }

  confirm () {
    this.setState({
      Confirm: {
        ...this.state.Confirm,
        Show: false
      }
    })

    if (this.state.Confirm.IsPermission) {
    } else {
      this.onCheckBoxChange(this.state.Confirm, true)
    }
  }

  notConfirm () {
    this.setState({
      Confirm: {
        ...this.state.confirm,
        Show: false
      }
    })
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecodes: state.common.phonecodes,
    vehicleLookupServices: state.common.vehicleLookupServices,
    languages: state.i18nState.languages,
    countries: state.common.countries,
    currencies: state.common.currencies
  }
}

export default connect(mapStateToProps, {
  getChain,
  getChainStats,
  createSaveChain,
  getCurrencies,
  loginAs
}, null, { withRef: true })(Create)



// WEBPACK FOOTER //
// ./src/app/pages/Chains/Create/index.js